import { render, staticRenderFns } from "./PackInfo.vue?vue&type=template&id=2fa5931a&scoped=true&"
import script from "./PackInfo.vue?vue&type=script&lang=js&"
export * from "./PackInfo.vue?vue&type=script&lang=js&"
import style0 from "./PackInfo.vue?vue&type=style&index=0&id=2fa5931a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa5931a",
  null
  
)

export default component.exports